<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2023-08-11 09:06:57
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-03-10 15:57:26
 * @FilePath: \jzjypc4.2\src\components\yuyueBox\yuyuebox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yuyueevm">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="400px"
      top="30vh"
    >
      <div class="yyevmContent">
        <div class="top">
          <h4>温馨提示</h4>
        </div>
        <h3 style="margin-bottom:0;">由于平台限制</h3>
        <h3 style="margin-top:0;">每个账号每天最多可下载10条资源</h3>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["zykf_file_url"],
  inject: ["reload"],
  data() {
    return {
      dialogVisible: true,
      dqkfevm: "", //公众号二维码
    };
  },
  methods: {
    handleClose() {
      this.$emit("gxtcClose");
    },
  },
};
</script>

<style lang="less" scoped>
.yuyueevm {
    
  /deep/.el-dialog__header {
    padding: 0;
  }
  /deep/.el-dialog {
    margin-top: 13vh !important;
    border-radius: 20px;
  }
  /deep/.el-dialog__body {
    padding: 0;
    // height: 450px;
  }
  /deep/.el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
  }
  .yyevmContent {
    width: 400px;
    // height: 500px;
    border-radius: 20px;
    overflow: hidden;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 120px;
      border-radius: 20px 20px 0px 0px;
      background-image: url("../../assets/img/activeNew/tcbg.png");
      background-size: 100%;
      background-repeat: no-repeat;
      img {
        // margin-right: 10px;
        width: 40px;
      }
      h4 {
        margin-left: 10px;
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 120px;
      }
    }
    h3 {
      margin: 0 auto;
      margin-top: 60px;
      margin-bottom: 80px;
      text-align: center;
      font-size: 18px;
      width: 324px;
      line-height: 30px;
      color: #333;
    }
    .signSuccessContent {
      overflow: hidden;
      .pic {
        margin: 0 auto;
        margin-bottom: 15px;
        width: 160px;
        height: 160px;
        border: 1px solid #dedede;
        img {
          width: 160px;
          height: 160px;
        }
      }
      p {
        text-align: center;
        width: 270px;
        margin: 0 auto;
        margin-bottom: 15px;
        text-align: center;
        font-size: 14px;
        color: #969799;
      }
    }
    .bottom{
        margin-bottom: 20px;
        text-align: center;
        width: 400px;
        img{
            width: 300px;
        }
    }
  }
}
</style>